var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFText } from '../../components';
import { useCFTestID } from '../../hooks';
import { CFAccordionElements } from './Accordion.styles';
import { CFAccordionTriggerIcon } from './AccordionTriggerIcon';
export const CFAccordionTrigger = (_a) => {
    var { fullWidth, label, panelActive } = _a, rest = __rest(_a, ["fullWidth", "label", "panelActive"]);
    const { commonAttrs, elementTestID, elementTestIDString } = useCFTestID('cf-accordion-trigger', rest);
    const { TriggerLabel, TriggerRoot } = CFAccordionElements;
    return (React.createElement(TriggerRoot, Object.assign({ "$fullWidth": fullWidth, "$panelActive": panelActive }, commonAttrs),
        React.createElement(TriggerLabel, Object.assign({ "$panelActive": panelActive }, elementTestID('label')), typeof label === 'string' ? (React.createElement(CFText, { spec: 'Subtitle1' }, label)) : (label)),
        React.createElement(CFAccordionTriggerIcon, { panelActive: panelActive, testID: elementTestIDString('icon') })));
};
